// ApiIntegrationsSection.jsx
import React from "react";
import { motion } from "framer-motion";

import pic1 from "../assets/pic1.png";
import pic2 from "../assets/pic2.png";
import pic3 from "../assets/pic3.png";
import pic4 from "../assets/pic4.png";
import pic5 from "../assets/pic5.png";
import pic6 from "../assets/pic6.png";
import pic7 from "../assets/pic7.png";
import pic8 from "../assets/pic8.png";
import pic9 from "../assets/pic9.png";
import pic10 from "../assets/pic10.png";
import pic11 from "../assets/pic11.png";
import pic12 from "../assets/pic12.png";
import pic13 from "../assets/pic13.png";
import pic14 from "../assets/pic14.png";
import pic15 from "../assets/pic15.png";
import pic16 from "../assets/pic16.png";
import pic17 from "../assets/pic17.png";
import pic18 from "../assets/pic18.png";
import pic19 from "../assets/pic19.png";
import pic20 from "../assets/pic20.png";
import pic21 from "../assets/pic21.png";
import pic22 from "../assets/pic22.png";
import pic23 from "../assets/pic23.png";
import pic24 from "../assets/pic24.png";
import pic25 from "../assets/pic25.png";
import pic26 from "../assets/pic26.png";
import pic27 from "../assets/pic27.png";
import pic28 from "../assets/pic28.png";
import pic29 from "../assets/pic29.png";

const ApiIntegrationsSection = () => {
  return (
    <>
      {/* 🔵 Integrations Section */}
      <section className="bg-[#d2e5e4] py-24 px-6 font-sans relative overflow-hidden">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
          {/* Left: Text Content */}
          <div className="md:w-1/2 text-center md:text-left relative z-10">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Integrations
            </h2>
            <p className="text-gray-700 text-lg md:text-xl mb-8">
              Seamlessly connecting healthcare applications and medical devices
              to ensure smooth operations and enhanced patient care.
            </p>
          </div>

          {/* Right: Orbiting Visual */}
          <div className="md:w-1/2 flex justify-center items-center relative">
            <div className="relative w-80 h-80 flex items-center justify-center">
              {/* Central Hub */}
              <div className="w-28 h-28 bg-[#f9c94e] text-black rounded-full flex items-center justify-center font-bold text-lg z-20 shadow-lg">
                Medimind
              </div>

              {/* Orbit ring 1 */}
              <div className="absolute w-60 h-60 border border-black rounded-full animate-spin-slow"></div>

              {/* Orbit ring 2 */}
              <div className="absolute w-96 h-96 border border-black rounded-full animate-spin-slower"></div>

              {/* Orbiting Nodes */}
              <div className="absolute w-60 h-60 flex items-center justify-center animate-spin-reverse-slow">
                <div className="absolute -top-4 w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center text-xs font-semibold text-white shadow">
                  App 1
                </div>
                <div className="absolute -bottom-4 w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center text-xs font-semibold text-white shadow">
                  Device 1
                </div>
              </div>

              <div className="absolute w-96 h-96 flex items-center justify-center animate-spin-reverse-slower">
                <div className="absolute left-0 w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center text-xs font-semibold text-white shadow">
                  App 2
                </div>
                <div className="absolute right-0 w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center text-xs font-semibold text-white shadow">
                  Device 2
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Background Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-200 opacity-20 rounded-full blur-3xl"></div>
      </section>

      {/* 🟢 Compliance Section */}
      <section className="bg-white px-6 py-8 font-sans w-full">
        <div className="max-w-6xl mx-auto text-center">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.3 }}
            className="text-2xl md:text-3xl font-bold mb-10 text-[#3d302c] text-left"
          >
            Accounting/ ERP/ CRM
          </motion.h2>

          {/* Horizontal Scroll Motion Wrapper */}
          <motion.div
            className="mt-6 w-full overflow-x-auto pb-6 px-4 no-scrollbar"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="flex gap-6 w-fit">
              {[
                { title: "Tally", alt: "DICOM Logo", image: pic1 },
                {
                  title: "Microsoft Dynamic AX",
                  alt: "ISO27001 Logo",
                  image: pic2,
                },
                {
                  title: "Microsoft Dynamic NAV",
                  alt: "ISO 9001 Logo",
                  image: pic3,
                },
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  className="relative flex-shrink-0 w-64 h-40 flex flex-col items-center justify-center 
                     bg-white border border-gray-300 rounded-lg hover:shadow-lg transition p-6"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.5,
                    ease: "easeOut",
                    delay: idx * 0.1,
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-24 h-16 object-contain"
                  />
                  <p className="mt-4 text-lg font-medium text-[#3d302c]">
                    {item.title}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      <section className="bg-[#f3f8f8] px-6 py-8 font-sans w-full">
        <div className="max-w-6xl mx-auto text-center">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.3 }}
            className="text-2xl md:text-3xl font-bold mb-10 text-[#3d302c] text-left"
          >
            EDC & POS Machines
          </motion.h2>

          {/* Horizontal Scroll Motion Wrapper */}
          <motion.div
            className="mt-6 w-full overflow-x-auto pb-6 px-4 no-scrollbar"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="flex gap-6 w-fit">
              {[{ image: pic4 }, { image: pic5 }, { image: pic6 }].map(
                (item, idx) => (
                  <motion.div
                    key={idx}
                    className="relative flex-shrink-0 w-64 h-40 flex flex-col items-center justify-center 
                     bg-white border border-gray-300 rounded-lg hover:shadow-lg transition p-6"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      duration: 0.5,
                      ease: "easeOut",
                      delay: idx * 0.1,
                    }}
                  >
                    <img
                      src={item.image}
                      alt={item.alt}
                      className="w-24 h-16 object-contain"
                    />
                    <p className="mt-4 text-lg font-medium text-[#3d302c]">
                      {item.title}
                    </p>
                  </motion.div>
                )
              )}
            </div>
          </motion.div>
        </div>
      </section>

      <section className="bg-white px-6 py-8 font-sans w-full">
        <div className="max-w-6xl mx-auto text-center">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.3 }}
            className="text-2xl md:text-3xl font-bold mb-10 text-[#3d302c] text-left"
          >
            Modalities
          </motion.h2>

          {/* Horizontal Scroll Motion Wrapper */}
          <motion.div
            className="mt-6 w-full overflow-x-auto pb-6 px-4 no-scrollbar"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="flex gap-6 w-fit">
              {[
                { title: "CT-scan", image: pic7 },
                { title: "MRI-scan", image: pic8 },
                { title: "PET-scan", image: pic9 },
                { title: "X-ray", image: pic10 },
                { title: "Ultrasound", image: pic11 },
                { title: "2D-Echo", image: pic12 },
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  className="relative flex-shrink-0 w-64 h-40 flex flex-col items-center justify-center 
                     bg-white border border-gray-300 rounded-lg hover:shadow-lg transition p-6"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.5,
                    ease: "easeOut",
                    delay: idx * 0.1,
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-24 h-16 object-contain"
                  />
                  <p className="mt-4 text-lg font-medium text-[#3d302c]">
                    {item.title}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      <section className="bg-[#f3f8f8] px-6 py-8 font-sans w-full">
        <div className="max-w-6xl mx-auto text-center">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.3 }}
            className="text-2xl md:text-3xl font-bold mb-10 text-[#3d302c] text-left"
          >
            Communications
          </motion.h2>

          {/* Horizontal Scroll Motion Wrapper */}
          <motion.div
            className="mt-6 w-full overflow-x-auto pb-6 px-4 no-scrollbar"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="flex gap-6 w-fit">
              {[
                { title: "Whatsapp", image: pic17 },
                { title: "SMS", image: pic18 },
                { title: "G-mail", image: pic19 },
                { title: "Chat-bot", image: pic20 },
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  className="relative flex-shrink-0 w-64 h-40 flex flex-col items-center justify-center 
                     bg-white border border-gray-300 rounded-lg hover:shadow-lg transition p-6"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.5,
                    ease: "easeOut",
                    delay: idx * 0.1,
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-24 h-16 object-contain"
                  />
                  <p className="mt-4 text-lg font-medium text-[#3d302c]">
                    {item.title}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

       <section className="bg-white px-6 py-8 font-sans w-full">
        <div className="max-w-6xl mx-auto text-center">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.3 }}
            className="text-2xl md:text-3xl font-bold mb-10 text-[#3d302c] text-left"
          >
           Picture Archiving and Communications System (PACS)
          </motion.h2>

          {/* Horizontal Scroll Motion Wrapper */}
          <motion.div
            className="mt-6 w-full overflow-x-auto pb-6 px-4 no-scrollbar"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="flex gap-6 w-fit">
              {[
                { title: "Radspa", alt: "DICOM Logo", image: pic21 },
                {
                  title: "Medsynapse",
                  alt: "ISO27001 Logo",
                  image: pic22,
                },
                {
                  title: "Tally",
                  alt: "ISO 9001 Logo",
                  image: pic23,
                },
                {
                  title: "Anids",
                  alt: "ISO 9001 Logo",
                  image: pic24,
                },
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  className="relative flex-shrink-0 w-64 h-40 flex flex-col items-center justify-center 
                     bg-white border border-gray-300 rounded-lg hover:shadow-lg transition p-6"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.5,
                    ease: "easeOut",
                    delay: idx * 0.1,
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-24 h-16 object-contain"
                  />
                  <p className="mt-4 text-lg font-medium text-[#3d302c]">
                    {item.title}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

        <section className="bg-[#f3f8f8] px-6 py-8 font-sans w-full">
        <div className="max-w-6xl mx-auto text-center">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.3 }}
            className="text-2xl md:text-3xl font-bold mb-10 text-[#3d302c] text-left"
          >
           Lab Analyzers
          </motion.h2>

          {/* Horizontal Scroll Motion Wrapper */}
          <motion.div
            className="mt-6 w-full overflow-x-auto pb-6 px-4 no-scrollbar"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="flex gap-6 w-fit">
              {[
                { title: "Accurex", image: pic25 },
                { title: "Acon", image: pic26 },
                { title: "Abbott", image: pic27 },
                { title: "Adonis", image: pic28 },
                { title: "Ali-fax", image: pic29 },
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  className="relative flex-shrink-0 w-64 h-40 flex flex-col items-center justify-center 
                     bg-white border border-gray-300 rounded-lg hover:shadow-lg transition p-6"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.5,
                    ease: "easeOut",
                    delay: idx * 0.1,
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-24 h-16 object-contain"
                  />
                  <p className="mt-4 text-lg font-medium text-[#3d302c]">
                    {item.title}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

       <section className="bg-white px-6 py-8 font-sans w-full">
        <div className="max-w-6xl mx-auto text-center">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.3 }}
            className="text-2xl md:text-3xl font-bold mb-10 text-[#3d302c] text-left"
          >
          Payment Gateways
          </motion.h2>

          {/* Horizontal Scroll Motion Wrapper */}
          <motion.div
            className="mt-6 w-full overflow-x-auto pb-6 px-4 no-scrollbar"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="flex gap-6 w-fit">
              {[
                { title: "UPI", alt: "DICOM Logo", image: pic13 },
                {
                  title: "Razorpay",
                  alt: "ISO27001 Logo",
                  image: pic14,
                },
                {
                  title: "PayUmoney",
                  alt: "ISO 9001 Logo",
                  image: pic15,
                },
                {
                  title: "Atom",
                  alt: "ISO 9001 Logo",
                  image: pic16,
                },
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  className="relative flex-shrink-0 w-64 h-40 flex flex-col items-center justify-center 
                     bg-white border border-gray-300 rounded-lg hover:shadow-lg transition p-6"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.5,
                    ease: "easeOut",
                    delay: idx * 0.1,
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-24 h-16 object-contain"
                  />
                  <p className="mt-4 text-lg font-medium text-[#3d302c]">
                    {item.title}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default ApiIntegrationsSection;
